// Type d'un fichier choisi parmi les types acceptés (règle `accept` de
// UiFormBuilder) ; type inconnu du navigateur (HEIC, HEIF) : son extension.
export function acceptedType(file, types) {
    if (file.type) return types.includes(file.type);
    const extension = (file.name.split('.').pop() || '').toLowerCase();
    return types.some((type) => type.split('/')[1] === extension);
}
